import * as React from 'react';
import Icon from 'src/core/ui/icon';
import { string } from 'prop-types';

export interface SelectProps {
    request?: () => Promise<any[]>;
    options?: any[];
    value?: any;
    keyProperty: string;
    mode: 'display' | 'edit';
    textProperty: string;
    style?: 'dark' | 'light' | 'grey' | 'fill';
    label?: string;
    labelCB?: (title: string) => string;
    placeholder?: string;
    required?: boolean;
    onChange?: (data: any) => void;
    as?: React.ReactNode;
    showArrow?: boolean;
    canFilter?: boolean;
    className?: string;
    errors?: string[];
    disabled?: boolean;
    formatter?: (value: string | any) => string;
}

export interface SelectState {
    show: boolean;
    value: any;
    options: any[];
    backup: any[];
    loading: boolean;

    filter: string;
}

export default class Select extends React.Component<SelectProps, SelectState> {
  constructor(props: SelectProps) {
    super(props);

    this.state = {
        show: false,
        value: this.props.value,
        options: [],backup: [],
        loading: false,
        filter: ''
    }
  }


  onChange = (e) => {
      this.setState({filter: e.target.value}, this.filterOptions);
  }

  filterOptions = () => {
    this.setState({options: [...this.state.backup.filter(r => (r[this.props.textProperty] as string).toLowerCase().startsWith(this.state.filter.toLowerCase()))]})
  }

  findSelectedOption = (value: any) => {
    
    if(!value || value == -1)
        return '';

    var result = this.state.backup.find(e => e[this.props.keyProperty] == value || e[this.props.keyProperty] == value[this.props.keyProperty]);

    if(this.props.labelCB)
      if(result)
        return this.props.labelCB(result[this.props.textProperty]);

    if(result)
        return result[this.props.textProperty];

    return value.toString();
  }

  public componentWillReceiveProps(nextProps: SelectProps){
      if(nextProps.value != this.props.value){
          console.log(nextProps.value)
          this.setState({value: nextProps.value})
      }
  }

  setValueIfNeeded = () => {
    if(this.props.required && this.state.options.length > 0 && !this.props.value){
        this.setState({value: this.state.options[0]});
    }
  }

  componentDidMount(){

    document.addEventListener('mousedown', this.handleClickOutside.bind(this));

      if(this.props.request){
          this.setState({loading: true});
          this.props.request().then(result => {
              this.setState({options: result, loading: false, backup: result});
              this.findSelectedOption(this.props.value);
          })
      }
      else if(this.props.options != null){
          this.setState({loading: false, options: this.props.options, backup: this.props.options});
      }

      this.setState({value: this.props.value});
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside.bind(this));
  }

  wrapperRef: any;
  filterRef: any;

  isInFilter = (event) => {
    if(!this.filterRef)
        return false;
    return this.filterRef.contains(event.target);

  }

  handleClickOutside = (event) => {
       if (this.wrapperRef != undefined){
         if(event
           && !this.wrapperRef.contains(event.target) 
           && (!this.isInFilter(event))
           && this.state.show) {
         this.toggleContent();
       }
     }
   }
   public toggleContent = () =>{


     this.setState({show: !this.state.show})
   }


   transformDisplay = (display: string) => {
    return display.toUpperCase();
   }


  getIsSelected = (item: any) => {
    return (!!this.state.value && (this.state.value == item[this.props.keyProperty] || this.state.value[this.props.keyProperty] == item[this.props.keyProperty]))?
    'selected':''
  }

  renderLabel = () => {

    const value = this.findSelectedOption(this.props.value) || '';

    if(!this.props.as)
        return this.props.formatter? this.props.formatter(value): value;
    else{
        return null;
    }
  }

  public render() {


    if(this.props.mode == 'display')
        return this.renderLabel();

    if(!this.state.options)
      return null;


    return (<div>
      <div onClick={() => {

        if(this.props.disabled)
          return;
        if(!this.state.show){
            
            this.setState({show: true})
            if(this.filterRef)
                this.filterRef.focus();
        }
 
      }} className={'select ' + (this.props.style || 'dark') + (this.props.label? ' ': ' non-label ') + (this.props.className? this.props.className: '')}   >
        <label className='select-label'>{this.props.label}</label>
        <div className='select-container' ref={e => this.wrapperRef = e}>
    <div className={`select-value `}  ><label className={` value ${!this.findSelectedOption(this.state.value)? 'placeholder': ''}`}>{(!this.findSelectedOption(this.state.value)) && this.props.placeholder}
    
    {(this.state.value && this.findSelectedOption(this.state.value))}</label> {this.props.showArrow && <Icon type='caret-down' />}
            </div>
            
            <div className='options-container'>
               
                {this.state.show && <ul className={`dropdown-options ${this.state.show? 'show':'hidden'}`}>
                {this.props.canFilter && this.state.show && <div ref={e => this.filterRef = e} className='option filter-option'>
                    <input placeholder="Search" onChange={this.onChange} value={this.state.filter} /> 
                </div>}
                {this.state.options.map((item, index) => {

                    const display = this.props.formatter? 
                      this.props.formatter(item[this.props.textProperty]? item[this.props.textProperty]: item):
                      item[this.props.textProperty];

                    return (
                        <li onClick={ (e) => {
                            if(this.props.onChange)
                                this.props.onChange(item);
                            this.setState({value: item, show: false, filter: ''});

                            
                        }} className={`option ${this.getIsSelected(item)}`} key={item[this.props.keyProperty] + index}>
                            <label>{display}</label>
                        </li>
                    )
                    })
                }</ul>}
            </div>
           
        </div>
        
      </div>
      {this.props.errors && <div className='inline-upload-errors'>
                {this.props.errors.map(item => {
                    return <p key={item} className='error-message'>{item}</p>
                })}
            </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/select.tsx